<template>
  <div>
    <transition name="fade" mode="out-in">
      <div
        v-if="isLoading"
        class="center-screen"
        key="main_screen">
          <div :style="`padding:20px;minheight:400px`">
            <img class="index-logo" src="static/indexnoslus.svg">
          </div>
      </div>
      <div v-else key="other_screen">
        <div v-if="showErr" class="center-screen">
          <div :style="cardStyle" :class="`${cardStyle.clientWidth >= 462 ? 'el-card is-always-shadow' : 'el-card'}`">
            <img class="index-logo" src="static/indexnoslus.svg">
            <h4 style="margin-top:70px;color:#E30015">{{server_err_mesage}}</h4>
            <transition name="fade">
              <div v-show="showErr">{{server_err_description}}</div>
            </transition>
          </div>
        </div>
        <div class="center-screen" v-else>
          <!-- LOGIN WINDOW -->
          <div v-if="showWindow=='login'" :style="cardStyle" :class="`${cardStyle.clientWidth >= 462 ? 'el-card is-always-shadow' : 'el-card'}`">
            <img class="index-logo" src="static/indexnoslus.svg">
            <h4 style="margin-top:30px">{{$t("webform.msg.login_title")}}</h4>
            <div style="padding: 14px;">
              <div class="bottom clearfix">
                <div style="height:54px">
                  <transition-group name="fade">
                    <div v-show="showMsg" key="t1" :style="`color:${color[color.set]}`">{{show_message}}</div>
                  </transition-group>
                </div>
                <div style="margin-top:30px;text-align:left;margin-bottom:5px"><b>{{macro === 'noslus_cz' ? 'Heslo' : $t("webform.lbl.pin_code")}}</b></div>
                <el-input 
                  @keyup.native.enter="detailForm()" 
                  :placeholder="`zde vložte ${macro === 'noslus_cz' ? 'heslo' : 'váš PIN kód'}`"
                  :type="`${macro === 'noslus_cz' ? 'password' : 'primary'}`"
                  v-model="pin"
                  :show-password="macro === 'noslus_cz'"
                  clearable>
                </el-input>
                <div :style="`text-align:left;margin-top:'-5px'`">
                  <div style="line-height:36px;display:block;height:56px">
                    <el-col :span="cardStyle_form.clientWidth >= 890 ? 6 : 24">
                      <transition name="fade">
                        <el-button v-show="showSendPin && macro !== 'noslus_cz'" type="text" @click="authForm('resend')" :disabled="disableSendPin">{{$t("webform.msg.resend_pin")}}</el-button>
                      </transition>
                    </el-col>
                    &nbsp;
                  </div>
                </div>
                <div :style="`text-align:right;`">
                  <el-button type="danger" :class="`${isDisabled ? 'btn-confirm-disabled' : 'btn-confirm'}`" :style="cardStyle_form.clientWidth >= 890 ? '' : 'width:calc(100%);'" :disabled="isDisabled" @click="detailForm()">Přihlásit</el-button>
                </div>
              </div>
            </div>
          </div>
          <!-- FORM WINDOW -->
          <div v-if="showWindow=='form'" :class="`${cardStyle_form.clientWidth >= 890 ? 'el-card is-always-shadow' : ''}`" :style="cardStyle_form">
            <img class="index-logo index-logo-left" src="static/indexnoslus.svg">
            <!-- flags... -->
            <div style="float:right;line-height:24px;">
              <img src="static/flag_ua.svg" :class="`flag_icon ${$i18n.locale === 'ua' ? 'flag_is_active' : 'flag_not_active'}`" @click="$i18n.locale='ua'" title="українська мова">
              <img src="static/flag_cz.svg" :class="`flag_icon ${$i18n.locale === 'cz' ? 'flag_is_active' : 'flag_not_active'}`" @click="$i18n.locale='cz'" title="český jazyk">
            </div>
            <div style="clear:both;"></div>
            <h3 style="margin-top:30px;">Vyplňte vaše údaje uchazeče</h3>
            <h4 style="color:#eb4c4e;margin-bottom:40px;">{{$t('webform.lbl.info_fields')}}</h4>
            <employee-form
              v-if="showWindow=='form'"
              ref="formEmp"
              @save="saveForm()"
              :dataForm="dataForm"
              :optData="{
                list: list,
                macro: macro,
                headers: {
                  'X-PIN': pin
                }
              }">
              <template v-slot:upload>
                <el-divider>
                  {{$t('webform.lbl.attachments')}}
                  <el-tooltip placement="top" effect="light">
                    <i class="far fa-question-circle tool-tip-form"></i>
                    <div slot="content">Zde nahrajte kopii občanského průkazu, kartičky zdravotní pojišťovny, potravinářský průkaz apod.</div>
                  </el-tooltip>
                </el-divider>
                <!-- UPLOAD -->
                <el-row style="text-align:left">
                  <el-col :span="24">
                    <el-upload id="hm" style="padding-left:0px;padding-top:20px"
                      drag
                      multiple
                      ref="upload"
                      :fileList="uload_fileList"
                      :action="upload_url"
                      :on-success="uploadSuccess"
                      :on-error="uploadError"
                      :on-change="uploadChange"
                      :on-remove="uploadRemove"
                      :headers="{'X-PIN': pin}"
                      :data="{
                        form_id: formID
                      }"
                      :auto-upload="false">
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">Sem přetáhněte soubor nebo <em> kliknutím nahrajte</em></div>
                      <!-- <el-button slot="trigger" size="small" type="primary">Zvolte soubor</el-button> -->
                      <!-- <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">upload to server</el-button> -->
                      <div class="el-upload__tip" slot="tip">
                        <div style="line-height:18px">Celková velikost všech souborů může být max 14MB</div>
                        <div v-if="upload_sum_file>0" style="line-height:14px">
                          Aktuální celková velikost {{parseFloat((upload_size_file / 1024 / 1024).toFixed(2))}}MB v počtu příloh: {{upload_sum_file}}
                        </div>
                      </div>
                    </el-upload>
                  </el-col>
                </el-row>
                <el-divider></el-divider>
              </template>
              <template slot-scope="props" slot="footer">
                <!-- BOTTOM ROW -->
                <el-row style="margin-top:40px">
                  <el-col :span="cardStyle_form.clientWidth >= 890 ? 14 : 24">
                    <div v-if="!uploadLimit">
                      <el-checkbox
                        v-model="dataForm.isGDPR"
                        style="line-height:36px;float:left;margin-right:10px"></el-checkbox>
                        <div style="text-align:left;font-size:13px;line-height:36px;">Souhlasím se zpracováním osobních údajů podle <el-button type="text" @click="openURL('https://indexnoslus.cz/ochrana-osobnich-udaju/')">GDPR</el-button></div>
                      </div>
                      <div style="both:clear;" :style="cardStyle_form.clientWidth >= 890 ? '' : 'margin-top:20px'"></div>
                    <span v-if="uploadLimit" style="float:left;color:#E30015;line-height:34px;">Velikost všech příloh je větší než 14 MB!</span>
                  </el-col>
                  <el-col :span="cardStyle_form.clientWidth >= 890 ? 10 : 24" style="text-align: right;line-height:36px">
                    <el-button @click="props.save"
                      :disabled="disableBtn"
                      :class="`${disableBtn===true ? 'btn-confirm-disabled' : 'btn-confirm'}`"
                      :loading="savingBtn"
                      :title="`${!dataForm.isGDPR ? 'S podmínkami GDPR je třeba souhlasit.' : ''}`"
                      :style="`${cardStyle_form.clientWidth >= 890 ? 'width:150px' : 'width:calc(100%);'}`">
                      {{$t('webform.lbl.btn_save')}}
                    </el-button>
                  </el-col>
                </el-row>
              </template>
            </employee-form>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
/* eslint-disable camelcase */
/* eslint-disable brace-style */
/* eslint-disable one-var */
/* eslint-disable standard/object-curly-even-spacing */
/* eslint-disable template-curly-spacing */
import {authForm, detailForm, updateForm, deleteFormFile} from '@/api/form'
import validity from '@/components/HMEmployeeForm/mixins/validity'
import EmployeeForm from '@/components/HMEmployeeForm'

export default {
  name: 'WebForm',
  mixins: [validity],
  components: {
    'employee-form': EmployeeForm
  },
  data () {
    return {
      list: false, // ked sa nastavi na true, zacnu sa nacitavat ciselniky
      showErr: false,
      server_err_mesage: '',
      server_err_description: '',
      isLoading: true,
      showMsg: false,
      showSendPin: true,
      disableSendPin: false,
      cardStyle: { padding: '0px', width: '482px', minheight: '400px', clientWidth: 482 },
      cardStyle_form: {
        'padding': '0px',
        'width': 'calc(100% - 60px)',
        'max-width': '900px',
        'clientWidth': 890
      },
      pin: '',
      macro: '',
      listMessage: [
        this.$t('webform.msg.list1'),
        this.$t('webform.msg.list2'),
        this.$t('webform.msg.list3'),
        this.$t('webform.msg.list4')
      ],
      nr_message: 0,
      show_message: '',
      color: {
        set: 'normal',
        normal: '#303133',
        error: '#E30015'
      },
      msg_timeout: undefined,
      isDisabled: true,
      showWindow: 'login', // 'login',
      dataForm: {
        sex: 0, // 0 -> ani hovno, 1 -> male, 2 -> female
        isGDPR: false,
        title: [],
        title_academic: [],
        address_street: '',
        address_street_nr: '',
        nrzip: '',
        city: '',
        country_id: undefined,
        citizenship_id: '',
        birth_nr: '',
        contact_address: {
          address_street: '',
          address_street_nr: '',
          nrzip: '',
          city: '',
          country_id: undefined
        },
        country_of_birth_id: undefined, // krajina narodenia
        email: '',
        emails: [],
        phones: []
      },
      savingBtn: false, // loading na tlacitku ULOZIT
      disableBtn: true, // povoli/blokuje tlacitko ULOZIT
      uploadLimit: false, // ak sa prekroci Limit uploadu, bude true
      upload_url: process.env.BASE_API + '/form/file_upload?form_id=' + this.$route.params.formID,
      upload_max_size: 14336, // max kapacita priloh v kB
      uload_fileList: [], // sem sa vklada zoznam uz nauploadovanych suborov ulozenych uz na serveri
      upload_count_file: 0, // pocitadlo kolko novych suborov sa aktualne prilozilo
      upload_size_file: 0, // velkost vsetkych priloh dokopy vcetne tych v DB
      upload_sum_file: 0, // pocet vsetkych priloh dokopy vcetne tych v DB
      /**
       * upload_remove_file:
       *  ked uchadzac odobere subor, ktory uz bol uploadovany do form.data.files, sem sa poznaci _id a po kliknuti
       *  na ULOZIT, sa na serveri odstrania prilohy s tymito _id. Jedna sa len o prilohy, ktore maju status: 'success'
       */
      upload_remove_file: [],
      formID: this.$route.params.formID
    }
  },
  computed: {
  },
  watch: {
    pin: function (newVal) {
      if (newVal.length > 0) {
        this.showSendPin = false // schovaj btn poslat PIN znovu
        if (!this.validNumeric(newVal)) {
          if (this.msg_timeout) {
            clearTimeout(this.msg_timeout)
          }
          this.showMsg = false
          this.msg_timeout = setTimeout(() => {
            this.nr_message = 1
            this.color.set = 'error'
            this.show_message = this.listMessage[this.nr_message]
            this.showMsg = true
          }, 600)
        } else {
          this.isDisabled = false
          this.confirmValid()
        }
      } else {
        this.confirmValid()
        this.showSendPin = true // ukaz btn poslat PIN znovu
        this.isDisabled = true
      }
    },
    'dataForm.country_id': function (newCountryId) {
      if (!this.dataForm.citizenship_id) {
        this.dataForm.citizenship_id = newCountryId
      }
    },
    upload_count_file: function (newVal) {
      console.log(`[WebForm.vue] pocet suborov pripravenych na upload =>`, newVal, `/`, this.upload_sum_file)
    },
    upload_size_file: function (newSize) {
      console.log(`[WebForm.vue] velkost vsetkych priloh vcetne ulozenych v DB =>`, newSize / 1024, `kB`)
      if ((newSize / 1024) > this.upload_max_size) {
        this.uploadLimit = true
      } else {
        this.uploadLimit = false
      }
    },
    uploadLimit: function () {
      this.handleDisabledBtnSave()
    },
    'dataForm.isGDPR': function () {
      this.handleDisabledBtnSave()
    }
  },
  mounted () {
    window.addEventListener('resize', () => {
      this.handleWindowSize(window.innerWidth)
    })
  },
  created () {
    this.handleWindowSize(window.innerWidth)
    this.show_message = this.listMessage[this.nr_message]
    if (this.validLink()) { // kontrola validity na klientskej strane
      this.authForm()
    }
    else {
      this.handleError({status: 500, data: {error: {err_code: 2}}})
      this.isLoading = false
    }
    setTimeout(() => {
      this.showMsg = true
    }, 800)
  },
  methods: {
    handleDisabledBtnSave () {
      this.disableBtn = true
      if (this.uploadLimit === false && this.dataForm.isGDPR === true) {
        this.disableBtn = false
      }
    },
    handleWindowSize (p_width) {
      // *** nastavenia pre login obrazovku
      this.cardStyle.clientWidth = p_width // nastav skutocnu sirku obrazovky
      this.cardStyle.width = p_width < 482 ? 'calc(100% - 30px)' : '482px' // okraje login okna pri desktope a mobile
      this.cardStyle.shadow = p_width > 482 ? 'always' : 'none' // desktop => zobraz tien pod el-card : maly displej(mobil) => vypni tien pod el-card
      this.cardStyle.padding = p_width > 890 ? '30px' : '20px 0px 20px 0px' // desktop => je padding 30px : maly displej(mobil) => je padding 0px
      // *** nastavenia pre formular
      this.cardStyle_form.clientWidth = p_width // nastav skutocnu sirku obrazovky
      this.cardStyle_form.width = p_width < 482 ? 'calc(100% - 30px)' : '890px' // okraje login okna pri desktope a mobile
      this.cardStyle_form.shadow = p_width > 890 ? 'always' : 'none' // desktop => zobraz tien pod el-card : maly displej(mobil) => vypni tien pod el-card
      this.cardStyle_form.padding = p_width > 890 ? '30px' : '0px' // desktop => je padding 30px : maly displej(mobil) => je padding 0px
    },
    confirmValid () {
      // eslint-disable-next-line eqeqeq
      if (this.nr_message == 0) return
      if (this.msg_timeout) {
        clearTimeout(this.msg_timeout)
      }
      this.showMsg = false
      this.msg_timeout = setTimeout(() => {
        this.nr_message = 0
        this.color.set = 'normal'
        this.show_message = this.listMessage[this.nr_message]
        this.showMsg = true
      }, 600)
    },
    validLink () { // je linka este platna?
      if (this.$route.params.expiration) {
        let expiration = this.$route.params.expiration
        let nowtimestamp = this.$moment().valueOf()
        if (nowtimestamp < expiration) {
          return true // validna
        } else {
          return false // nevalidna
        }
      } else {
        return false // nevalidna
      }
    },
    authForm (p_only_resend) { // overuje odkaz a posle PINkod
      let query = {
        form_id: this.$route.params.formID,
        expiration: this.$route.params.expiration,
        pin_resend: p_only_resend || undefined
      }
      if (p_only_resend === 'resend') {
        this.disableSendPin = true
        this.nr_message = 3
        this.show_message = this.listMessage[this.nr_message]
        setTimeout(() => {
          this.disableSendPin = false
          this.nr_message = 0
          this.show_message = this.listMessage[this.nr_message]
        }, 10000)
      }
      authForm(query).then((response) => {
        this.macro = (response.headers && response.headers['x-macro']) || ''
        this.listMessage[0] = this.$t(`webform.msg.${this.macro}_list1`)
        this.listMessage[1] = this.$t(`webform.msg.${this.macro}_list2`)
        this.listMessage[2] = this.$t(`webform.msg.${this.macro}_list3`)
        this.show_message = this.listMessage[this.nr_message]
        let result = response.data
        this.pin = (result && result.temp_pin) || this.pin
        if (this.pin && this.pin !== '') {
          this.detailForm()
        } else {
          // HOTOVO
          this.isLoading = false
        }
      })
        .catch((err) => {
          this.isLoading = false
          console.error(`[webform.vue] authForm ! err`, err)
          this.handleError(err)
        })
    },
    detailForm () {
      let form_id = this.$route.params.formID
      let headers = {
        'X-PIN': this.pin
      }
      detailForm({ form_id: form_id }, headers).then((response) => {
        this.macro = (response.headers && response.headers['x-macro']) || ''

        this.dataForm = Object.assign({}, this.dataForm, response.data.data)
        this.dataForm.contact_address = this.dataForm.contact_address ? this.dataForm.contact_address : { address_street: '', address_street_nr: '', nrzip: '', city: '', country_id: undefined }
        if (this.dataForm.files) {
          this.upload_sum_file = this.dataForm.files.length
          for (let index = 0; index < this.dataForm.files.length; index++) {
            const file = this.dataForm.files[index]
            this.uload_fileList.push({ // zobraz v komponente el-upload, uz nauploadovane subory
              _id: file._id,
              name: file.fileName,
              size: file.length
            })
            this.upload_size_file += file.length
          }
        }
        this.list = true // daj povel k nacitaniu ciselnikov v komponete <employee-form></employee-form>
        this.dataForm.isGDPR = false // aj ked predtym zaskrtol odsuhlasenie GDPR, znova to musi odsuhlasit ak spravil nejaku zmenu vo formulari
        this.showWindow = 'form'
        this.isLoading = false
      })
        .catch((err) => {
          this.isLoading = false
          console.error(`[webform.vue] detailForm ! err`, err)
          this.handleError(err)
        })
    },
    handleError (err) {
      // chyby sa zobrazia v login okne nad inputom
      if (err.status === 500) {
        if (err.data && err.data.error.err_code === 1) { // PIN is not valid for form ID.
          this.nr_message = 2
          this.show_message = this.listMessage[this.nr_message]
          this.color.set = 'error'
        }
      }
      // chyba zmizne za 7 sek
      setTimeout(() => {
        this.nr_message = 0
        this.show_message = this.listMessage[this.nr_message]
        this.color.set = 'normal'
      }, 7000)
      // ---
      // chyby sa zobrazia ako samostany el-card(okienko)
      if (err.toString() === 'Network Error') {
        this.showErr = true
        this.server_err_mesage = this.$t('webform.msg.err_link_title')
        this.server_err_description = this.$t('webform.msg.err_link_desc')
        setTimeout(() => {
          this.showErr = false
        }, 5000)
      }
      if (err.status === 500) {
        console.log('error 500', err)
        if (err.data && err.data.error.err_code === 2) { // vyprsalo casove okno, The link has expired.
          this.showErr = true // zobraz samostatne okienko s chybou
          this.server_err_mesage = this.$t('webform.msg.err_link_title1')
          this.server_err_description = this.$t('webform.msg.err_link_desc1')
        }
        if (err.data && err.data.error.err_code === 3) { // blby odkaz, Illegal link duration manipulation!
          this.showErr = true // zobraz samostatne okienko s chybou
          this.server_err_mesage = this.$t('webform.msg.err_link_title2')
          this.server_err_description = this.$t('webform.msg.err_link_desc2')
        }
        if (err.data && err.data.error.err_code === 4) { // data formularu uz schvalil uzivatel
          this.showErr = true // zobraz samostatne okienko s chybou
          this.server_err_mesage = this.$t('webform.msg.err_link_title3')
          this.server_err_description = this.$t('webform.msg.err_link_desc3')
        }
        if (err.data && err.data.error.err_code === 5) { // ostatne chyby
          this.showErr = true // zobraz samostatne okienko s chybou
          this.server_err_mesage = this.$t('webform.msg.err_link_title4')
          this.server_err_description = this.$t('webform.msg.err_link_desc4') // err.data.error.err_message
        }
        // update - saveForm => zobrazi sa notify okno
        if (err.data && err.data.error.err_code === 6) { // ostatne chyby pri ukladani
          this.$notify({
            title: this.$t('webform.lbl.title'),
            message: this.$t('webform.msg.err_not_save'),
            type: 'error'
          })
        }
      }
    },
    handleStep (p_direction) {
      // poznac si aktualny krok
      this.currentStep = this.showStep
      // schovaj aktualny krok
      this.showStep = -1 // zacne animacia
      if (p_direction === 'up') {
        setTimeout(() => {
          this.showStep = this.currentStep + 1 // zacne animacia dlasie kroku
          this.currentStep = this.showStep
        }, 400)
      } else {
        setTimeout(() => {
          this.showStep = this.currentStep - 1 // zacne animacia dlasie kroku
          this.currentStep = this.showStep
        }, 400)
      }
    },
    // sPHONE
    disabledAddButton (typ) {
      if (typeof this.dataForm[typ] === 'undefined') return false
      if (this.dataForm[typ].length > 0) {
        if (typ === 'phones') { if (this.dataForm[typ][this.dataForm[typ].length - 1].number !== '') { return false } else { return true } }
        if (typ === 'emails') { if (this.dataForm[typ][this.dataForm[typ].length - 1].address !== '') { return false } else { return true } }
      }
    },
    removeRowFields (item, typ) {
      var index = this.dataForm[typ].indexOf(item)
      if (index !== -1) {
        this.dataForm[typ].splice(index, 1)
      }
      this.checkIsDefault(typ)
    },
    addRowFileds (typ) {
      this.dataForm[typ] = this.dataForm[typ] ? this.dataForm[typ] : []

      if (this.dataForm[typ].length > 0) { // nepridavaj ak v poslednom riadku nie je vyplnene tel. cislo
        if (typ === 'phones') { if (this.dataForm[typ][this.dataForm[typ].length - 1].number === '') return }
        if (typ === 'emails') { if (this.dataForm[typ][this.dataForm[typ].length - 1].address === '') return }
      }

      var obj
      if (this.dataForm[typ].length > 0) {
        if (typ === 'phones') {
          obj = {
            key: this.dataForm[typ].length - 1,
            number: '',
            default: false,
            _type: 'mobile'
            // allow_sending: true
          }
        }
        if (typ === 'emails') {
          obj = {
            key: this.dataForm[typ].length - 1,
            address: '',
            default: false,
            _type: 'home'
            // allow_sending: true
          }
        }
      } else { // ked este neni ziadny riadok
        if (typ === 'phones') {
          obj = {
            key: this.dataForm[typ].length - 1,
            number: '',
            default: true,
            _type: 'mobile'
            // allow_sending: true
          }
        }
        if (typ === 'emails') {
          obj = {
            key: this.dataForm[typ].length - 1,
            address: '',
            default: true,
            _type: 'home'
            // allow_sending: true
          }
        }
      }
      this.dataForm[typ].push(obj)
    },
    checkIsDefault (typ) { // v pripade, ked sa odstrani defaultne cislo, nastav defaultnym [0] polozku v array
      var hasDefault = false
      this.dataForm[typ].map(function (item) {
        if (item.default) hasDefault = true
      })
      if ((this.dataForm[typ].length > 0) && (hasDefault === false)) { this.dataForm[typ][0].default = true }
    },
    // ePHONE
    saveForm () {
      this.savingBtn = true
      let form_id = this.$route.params.formID
      let headers = {
        'X-PIN': this.pin
      }
      this.dataForm.form_id = form_id
      if (this.dataForm.telephone && this.dataForm.telephone.length > 0) {
        this.dataForm.telephone = this.dataForm.phone_prefix + this.dataForm.telephone
      }
      updateForm(this.dataForm, headers).then((response) => {
        // A. ak su nejake subory na odmazanie z DB tak odmaz...
        if (this.upload_remove_file.length > 0) {
          deleteFormFile({form_id: form_id, remove_file: this.upload_remove_file}, headers).then((resp) => {
            // resp
          })
          .catch((err) => {
            console.error(`[webform.vue] saveForm ! err, (deleteFormFile)`, err)
          })
          .finally (() => { 
            // A1. ak su nejake subory na upload
            if (this.upload_count_file > 0) {
              this.$refs.upload.submit() // zacni uploadovat
            }
            else { // inak
              this.formDone() // podakuj a ukonci formular
            }
          })
        } else { // ak nie su subory na odmazanie z DB tak...
          // B. zisti ak su nejake subory na upload
          if (this.upload_count_file > 0) {
            this.$refs.upload.submit() // zacni uploadovat
          }
          else { // inak
            this.formDone() // podakuj a ukonci formular
          }
        }
      })
        .catch((err) => {
          console.error(`[webform.vue] saveForm ! err`, err)
          this.handleError(err)
          this.savingBtn = false
        })
    },
    uploadSuccess (p_response, p_file, p_fileList) {
      let countSuccess = 0
      for (let index = 0; index < p_fileList.length; index++) {
        const file = p_fileList[index]
        if (file.status === 'success') {
          countSuccess++
        }
      }
      if (countSuccess === p_fileList.length) {
        this.formDone() // ak vsetky prilohy maju status success, podakuj a ukonci formular
      }
    },
    uploadChange (p_file, p_fileList) {
      // console.log("file", p_file)
      // console.log("fileList CHANGE", p_fileList)
      this.upload_count_file = 0
      this.upload_size_file = 0
      this.upload_sum_file = 0
      for (let index = 0; index < p_fileList.length; index++) {
        const file = p_fileList[index]
        if (file.status === 'ready') {
          this.upload_count_file++ // celkom priloh na upload
        }
        this.upload_size_file += file.size // velkost vsetkych suborov spolu
        this.upload_sum_file++ // celkom priloh vcetne tych v DB
      }
    },
    uploadRemove (p_file, p_fileList) {
      // console.log("fileList REMOVE", p_fileList)
      if (p_file.status === 'success') {
        this.upload_remove_file.push(p_file._id)
      }
      console.log("files to REMOVE =>", this.upload_remove_file)
      this.upload_count_file = 0
      this.upload_size_file = 0
      this.upload_sum_file = 0
      for (let index = 0; index < p_fileList.length; index++) {
        const file = p_fileList[index]
        if (file.status === 'ready') {
          this.upload_count_file++ // celkom priloh na upload
        }
        this.upload_size_file += file.size // velkost vsetkych suborov spolu
        this.upload_sum_file++ // celkom priloh vcetne tych v DB
      }
    },
    uploadError (p_err, p_file, p_fileList) {
      this.$notify({
        title: 'Přílohy',
        message: `Při odesílaní přílohy nastala chyba. Soubor ${p_file.name} se nepodařilo uploadovat, zkuste to prosím znovu.`,
        type: 'warning'
      })
      this.savingBtn = false
    },
    formDone () {
      this.savingBtn = false
      this.showErr = true // zobraz samostatne okienko
      this.server_err_mesage = 'Formulář odeslán.'
      this.server_err_description = 'Formulář byl úspěšně odeslán. Děkujeme Vám za vyplnění.'
    },
    openURL (p_url) {
      window.open(p_url, '_blank')
    },
  }
}
</script>

<style>
body {
  margin: 0px;
  background-color: #F9F9F9;
}

.center-screen {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  min-height: 90vh;
}
.index-logo {
  height: 40px;
  width: auto;
}
.index-logo-left {
  float: left;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.btn-confirm-disabled {
  background-color:#eb4c4e !important;
  border: 0px;
  color:whitesmoke !important;
}
.btn-confirm-disabled:hover {
  background-color:#eb4c4e;
  color:whitesmoke;
}
.btn-confirm {
  background-color:#E30015;
  border: 0px;
  color:whitesmoke;
}
.btn-confirm:hover {
  background-color:hsla(354, 100%, 45%, 0.822);
  color:whitesmoke;
}
.input-with-select .el-input-group__prepend {
  background-color: #fff;
}
#hm .el-upload {
  width: calc(100%) !important;
}
#hm .el-upload-dragger {
  width: 100% !important;
}
.flag_icon {
  height: 20px;
  width: auto;
  cursor: pointer;
  border: 1px solid #f2f2f2;
}
.flag_is_active {
  height: 24px;
  box-shadow: 1px 1px #f2f2f2;
}
.flag_not_active {
  filter: grayscale(100%);
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.7s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.fade-enter-to, .fade-leave {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/WebForm/WebForm.vue